import { memo, PropsWithChildren } from 'react';
import { Modal, ModalBody, ModalContent, ModalHeader } from '@heroui/react';
import { scaleInOut } from '@/shared/lib/utils/modalTransitions';
import { useModalAutoFocus } from '@/shared/lib/hooks';

interface FilterModalProps extends PropsWithChildren {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
}

export const FilterModal = memo(({ isOpen, onOpenChange, children }: FilterModalProps) => {
  useModalAutoFocus(isOpen);

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      placement="center"
      backdrop="opaque"
      size="5xl"
      motionProps={scaleInOut}
      classNames={{
        base: 'p-6 gap-4',
        closeButton: 'absolute top-[18px] right-4 [&_svg]:w-6 [&_svg]:h-6',
      }}
    >
      <ModalContent>
        <ModalHeader className="text-3xl font-medium text-red p-0">Filters</ModalHeader>
        <ModalBody className="p-0">{children}</ModalBody>
      </ModalContent>
    </Modal>
  );
});
